import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  openOrders: [],
  marginOpenOrders: [],
};

const handleSetOpenOrders = (state, { data }) => ({
  ...state,
  openOrders: [...data],
});

const handleSetMarginOpenOrders = (state, { data }) => ({
  ...state,
  marginOpenOrders: [...data],
});

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_OPEN_ORDERS_DATA:
      return handleSetOpenOrders(state, action);
    case actionTypes.SET_MARGIN_OPEN_ORDERS_DATA:
      return handleSetMarginOpenOrders(state, action);
    default:
      return state;
  }
};
